var map = {
	"./message_en.json": [
		64499,
		6880
	],
	"./message_es.json": [
		51368,
		1368
	],
	"./message_id.json": [
		9293,
		9293
	],
	"./message_ja.json": [
		42929,
		2929
	],
	"./message_ko.json": [
		26482,
		6482
	],
	"./message_th.json": [
		38656,
		8656
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 18070;
module.exports = webpackAsyncContext;